var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('video',{style:({position: 'absolute',
          top: _vm.$store.getters.getScreenWidth>500 ? '0%' : '5%',
          bottom: 0,
          right: 0, 
          left: '0%',
          margin: 'auto',
          width: '100%',
          minWidth: '100%',
          filter: 'opacity(100%)', zIndex: '-999'}),attrs:{"autoplay":true,"controls":false,"loop":"","playsinline":"","id":"myVideo","data-source-type":"video","data-movie-id":"194603","poster":"https://raizzoncdn.b-cdn.net/coastalkia5k/poster.jpeg"},on:{"click":_vm.playVideo}},[_c('source',{attrs:{"src":"https://shaklee-plugin.b-cdn.net/CSK_Shaklee_2024_c.mp4","type":"video/mp4"}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f8d0ef34","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/BGVideo.vue
// module id = 53
// module chunks = 0